import * as React from 'react'
import { Field } from '@metrisk/react_metrisk-components'
import { useIntl } from 'react-intl'
interface DefaultInputsProps {
  value?: any
  onChange?: any
}

const DefaultInputs: React.FunctionComponent<DefaultInputsProps> = (props) => {
  const intl = useIntl()
  const { value, onChange } = props
  const [valid, setValid] = React.useState({ accountName: null, iban: null, bicSwift: null })

  const handleAccountName = (input: string) => {
    const updatedValid = { ...valid, ...{ accountName: !!input } }
    const validBankDetails = Object.values(updatedValid).every(Boolean)
    setValid(updatedValid)
    onChange({ ...value, ...{ accountName: input, valid: validBankDetails } })
  }

  const handleIban = (input: string) => {
    input = input.length <= 34 ? input : value.iban
    const validIban = RegExp(/^[A-Za-z0-9]{5,34}$/).test(input)
    const updatedValid = { ...valid, ...{ iban: validIban } }
    const validBankDetails = Object.values(updatedValid).every(Boolean)
    setValid(updatedValid)
    onChange({ ...value, ...{ iban: input, valid: validBankDetails } })
  }

  const handleBicSwift = (input: string) => {
    input = input.length <= 11 ? input : value.bicSwift
    // Validate
    const validBicSwift = RegExp(/^[A-Za-z0-9]{8,11}$/).test(input)
    const updatedValid = { ...valid, ...{ bicSwift: validBicSwift } }
    const validBankDetails = Object.values(updatedValid).every(Boolean)
    setValid(updatedValid)
    onChange({ ...value, ...{ bicSwift: input, valid: validBankDetails } })
  }

  return (
    <>
      <Field
        key={`field-accountName`}
        id={`accountName`}
        className="bank-details__input"
        name={`accountName`}
        label={intl.formatMessage({ defaultMessage: 'Account Name *' })}
        type={'text'}
        value={value?.accountName}
        placeholder="John Smith"
        onChange={handleAccountName}
        fullWidth
        msg={
          valid.accountName === null
            ? null
            : valid.accountName
            ? ''
            : intl.formatMessage({ defaultMessage: 'Please enter a valid account name' })
        }
        state={valid.accountName === null ? null : valid.accountName ? 'Success' : 'Error'}
      />
      <Field
        key={`field-iban`}
        id={`iban`}
        className="bank-details__input"
        name={`iban`}
        label={intl.formatMessage({ defaultMessage: 'IBAN *' })}
        type={'text'}
        value={value?.iban}
        placeholder="IE64IRCE00000000000000"
        onChange={handleIban}
        fullWidth
        msg={valid.iban === null ? null : valid.iban ? '' : 'Please enter a valid IBAN'}
        state={valid.iban === null ? null : valid.iban ? 'Success' : 'Error'}
      />
      <Field
        key={`field-bicSwift`}
        id={`bicSwift`}
        className="details__input bank-details__bic"
        name={`bicSwift`}
        label={intl.formatMessage({ defaultMessage: 'BIC / Swift *' })}
        type={'text'}
        value={value?.bicSwift}
        placeholder="NEWMRB22"
        onChange={handleBicSwift}
        fullWidth
        msg={
          valid.bicSwift === null
            ? null
            : valid.bicSwift
            ? ''
            : intl.formatMessage({ defaultMessage: 'Please enter a valid bicSwift. e.g. BUKBGB22' })
        }
        state={valid.bicSwift === null ? null : valid.bicSwift ? 'Success' : 'Error'}
      />
    </>
  )
}

export default DefaultInputs
